export const T = {
  en_GB: { loading: "Loading call...", fallbackTitle: "Call" },
  nb_NO: { loading: "Laster samtale...", fallbackTitle: "Samtale" },
} as const;
